<template>
	<ValidationForm
			v-model="formFields"
			:form-schema="formSchema"
			:loading="loading"
			:stop-propagation="!formIsRequired"
			@cancel="$emit('cancel')"
			@submit="submit"
	/>
</template>

<script lang="ts" setup>
	import type {PropType} from 'vue';
	import ValidationForm from '~/components/forms/ValidationForm.vue';
	import type {ExistingResponsibleCommand, NewResponsibleCommand} from '~/lib/types/responsibleTypes';
	import {useResponsiblesForm} from '~/composables/useResponsibleForm';

	const props = defineProps({
		companyId: {
			type: String,
			required: true
		},
		initialResponsible: {
			type: Object as PropType<ExistingResponsibleCommand>,
			default: undefined
		},
		loading: {
			type: Boolean,
			default: false
		},
		formIsRequired: {
			type: Boolean,
			default: true
		}
	});

	const emit = defineEmits<{
		// eslint-disable-next-line no-unused-vars
		(e: 'submit', responsible: ExistingResponsibleCommand | NewResponsibleCommand): void
		// eslint-disable-next-line no-unused-vars
		(e: 'cancel'): void
	}>();

	const {
		formSchema,
		formFields
	} = useResponsiblesForm(props.initialResponsible);

	const submit = () => {
		emit('submit', formFields.value);
	};

</script>
